import { PatientFilters } from './types'

export const DEFAULT_PATIENT_FILTERS: PatientFilters = {
  searchTerm: '',
  displayedType: 'all',
  gender: 'all',
  language: 'all',
  sort: { field: 'createdAt', direction: false },
  ageMin: '0',
  ageMax: '150',
  scoreMin: '0',
  scoreMax: '59',
  institution: '',
}
